import { createApp } from "vue";
import App from "./App.vue";
import vClickOutside from "click-outside-vue3";
import { createPinia } from "pinia";
import i18nSetup from "@templates/components/treeView-vue3/i18n";
import { useHistoricStore, writeHistoricToLocaleStorage } from '../treeViewSearch/plugins/store/historic.store';
import "@assets/css/theme/pages/tree-view.scss";
import { getOriginTaFromUrl } from "@templates/components/structures/select-ta";

(async () => {
  const treeViewTaListing = document.getElementById("tree-view-anatomical");

  const pinia = createPinia();

  const jsonString = treeViewTaListing.dataset.preloadedNodes;
  const treeViewArray = JSON.parse(jsonString);
  const keys = JSON.parse(treeViewTaListing.dataset.treeKeys); // [2, 1, 5]

  let finalTreeData = {};

  /**
   * Unsorted treeViewArray
   * from { 1: [], 2: [], 5: [] }
   * to { "ta-2": [], "ta-1": [], "ta-5": [] }
   */
  keys.forEach(key => {
    finalTreeData[`ta-${key}`] = treeViewArray[key] || [ ];
  })

  const taFromUrlOrContent = getOriginTaFromUrl();

  const app = createApp(App, {
    preloadedNodes: finalTreeData,
    selectedNodePath: treeViewTaListing.dataset.nodePath,
    currentTaId: taFromUrlOrContent,
    treeKeys: keys
  });

  app.use(vClickOutside);
  app.use(await i18nSetup());
  app.use(pinia);
  app.mount(treeViewTaListing);

  /**
   * Replace root element with the element app itself
   * see another solution with create Fragment but app.mount() not support DocumentFragment, it works but not guaranteed
   * https://stackoverflow.com/questions/76634546/vue-3-render-function-app-mounts-inside-root-element-via-innerhtml-instead-of-r
   */
   const renderedRoot = treeViewTaListing.firstElementChild;
   treeViewTaListing.parentNode.replaceChild(renderedRoot, treeViewTaListing);

  useHistoricStore().$subscribe((mutation, state) => {
    if (mutation.storeId === 'historic') {
      writeHistoricToLocaleStorage(state.historic);
    }
  });
})();
